import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AdaptiveImageComponentModule } from 'ib/internetbank-core/ib-components/adaptive-image/adaptive-image.module';

import { UiModule } from '../../ui/ui.module';

import { StoriesComponent } from './stories.component';
import { StoriesDataService } from './stories.data.service';
import { StoriesFacadeService } from './stories.facade.service';
import { StoryComponent } from './story/story.component';
import { StoryPopUpComponent } from './story-pop-up/story-pop-up.component';

@NgModule({
	imports: [
		CommonModule,
		UiModule,
		RouterModule,

		AdaptiveImageComponentModule,
	],
	declarations: [
		StoriesComponent,
		StoryComponent,
		StoryPopUpComponent,
	],
	exports: [
		StoriesComponent,
		StoryComponent,
		StoryPopUpComponent,
	],
	providers: [
		StoriesFacadeService,
		StoriesDataService,
	],

})
export class StoriesModule { }
